import { StateCreator } from "zustand";

export interface UploadPhotoSlice {
  imageUrl: string | ArrayBuffer | null;
  selectedImage: File | null;
  blobEndpoint: string;
  blobUri: string;
  imageThumbnail: string;
  classification: string;
  latitude: number;
  longitude: number;
  imageUploadError: string;
  filename: string;
  updateImageUrl: (imageUrl: string | ArrayBuffer | null) => void;
  updateSelectedImage: (selectedImage: File | null) => void;
  updateBlobEndpoint: (blobImage: string) => void;
  updateBlobUri: (blobUri: string | undefined) => void;
  updateImageThumbnail: (imageThumbnail: string) => void;
  updateClassification: (classification: string) => void;
  updateLatitude: (latitude: number) => void;
  updateLongitude: (latitude: number) => void;
  updateImageUploadError: (imageUploadError: string) => void;
  updateFilename: (filename: string) => void;
  resetAllUploadPhoto: () => void;
}

export const createUploadPhotoSlice: StateCreator<
  UploadPhotoSlice,
  [],
  [],
  UploadPhotoSlice
> = (set) => ({
  imageUrl: "",
  selectedImage: null,
  blobUri: "",
  blobEndpoint: "",
  imageThumbnail: "",
  classification: "",
  latitude: 0,
  longitude: 0,
  imageUploadError: "",
  filename: "",
  updateFilename: (filename) => set(() => ({ filename })),
  updateImageUrl: (imageUrl) => set(() => ({ imageUrl })),
  updateSelectedImage: (selectedImage) => set(() => ({ selectedImage })),
  updateBlobUri: (blobUri) => set(() => ({ blobUri })),
  updateBlobEndpoint: (blobEndpoint) => set(() => ({ blobEndpoint })),
  updateImageThumbnail: (imageThumbnail) => set(() => ({ imageThumbnail })),
  updateClassification: (classification) => set(() => ({ classification })),
  updateLatitude: (latitude) => set(() => ({ latitude })),
  updateLongitude: (longitude) => set(() => ({ longitude })),
  updateImageUploadError: (imageUploadError) =>
    set(() => ({ imageUploadError })),
  resetAllUploadPhoto: () =>
    set(() => ({
      imageUrl: "",
      selectedImage: null,
      blobUri: "",
      blobEndpoint: "",
      imageThumbnail: "",
      classification: "",
      latitude: 0,
      longitude: 0,
      imageUploadError: "",
      filename: "",
    })),
});
